var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18C4.03749 18 2.44128e-06 13.9625 1.57361e-06 9C7.05937e-07 4.03749 4.03749 -7.05937e-07 9 -1.57361e-06C13.9625 -2.44128e-06 18 4.03749 18 8.99999C18 13.9625 13.9637 18 9 18ZM9 0.610168C4.37369 0.610169 0.61017 4.37369 0.610171 9C0.610172 13.6263 4.3737 17.3898 9 17.3898C13.6263 17.3898 17.3898 13.6263 17.3898 8.99999C17.3898 4.37369 13.6263 0.610167 9 0.610168Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4259 5.68115L8.80847 8.30216L6.19105 5.68115L5.68121 6.19099L8.30222 8.80841L5.68121 11.4258L6.19105 11.9357L8.80847 9.31466L11.4259 11.9357L11.9357 11.4258L9.31472 8.80841L11.9357 6.19099L11.4259 5.68115Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancelIcon.fb185d970883897d93afa053563546c0.svg";
export { ForwardRef as ReactComponent };